import { useState, useEffect, useContext } from 'react';
import { 
  signInWithPopup,
  signOut as firebaseSignOut, 
  onAuthStateChanged,
  User 
} from 'firebase/auth';
import { auth, googleProvider } from '../services/firebase';
import { AuthContext } from '../contexts/AuthContext';

export function useAuth() {
  const context = useContext(AuthContext);
  
  // Se estiver sendo usado dentro do AuthProvider, retorna o contexto
  if (context !== undefined) {
    return context;
  }

  // Caso contrário, cria uma nova instância (para o AuthProvider)
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const signInWithGoogle = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      return result.user;
    } catch (error: any) {
      console.error('Erro detalhado ao fazer login:', error);
      
      // Mensagens de erro mais específicas
      if (error.code === 'auth/popup-closed-by-user') {
        throw new Error('Você fechou a janela de login');
      } else if (error.code === 'auth/popup-blocked') {
        throw new Error('O navegador bloqueou o popup de login. Por favor, permita popups para este site e tente novamente.');
      } else if (error.code === 'auth/unauthorized-domain') {
        throw new Error('Domínio não autorizado. Configure o Firebase corretamente.');
      } else if (error.code === 'auth/invalid-api-key') {
        throw new Error('Chave de API inválida. Configure o Firebase corretamente.');
      } else if (error.code === 'auth/configuration-not-found') {
        throw new Error('Configuração do Firebase não encontrada. Verifique as credenciais.');
      }
      
      throw error;
    }
  };

  const signOut = async () => {
    try {
      await firebaseSignOut(auth);
    } catch (error) {
      console.error('Erro ao fazer logout:', error);
      throw error;
    }
  };

  return {
    user,
    loading,
    signInWithGoogle,
    signOut
  };
}
